import React, { useCallback, useMemo, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { alpha } from "@mui/material/styles";
import HomeTimeCapsuleMapV2 from "./HomeTimeCapsuleMapV2";
import HomeGraphicalTiltMap3D from "./HomeGraphicalTiltMap3D";

export default function HomeMapStage({
  mapRenderCenter,
  userLocation,
  displayItems,
  directions,
  onLoad,
  onDrag,
  onDragEnd,
  onIdle,
  onMarkerClick,
  onClusterClick,
  onLongPress,
  onPoiClick,
  mapOptions,
  mapContainerStyle,
  deferMapRender = false,
}) {
  const [has3dFallback, setHas3dFallback] = useState(false);

  const handleFallbackTo2D = useCallback((error) => {
    console.warn("[home-map-3d] Falling back to 2D map:", error);
    setHas3dFallback(true);
  }, []);

  const shouldRender3d = !has3dFallback;
  const graphicalMapOptions = useMemo(() => {
    if (!shouldRender3d) return mapOptions;
    return {
      ...mapOptions,
      mapTypeId: "roadmap",
      renderingType: "VECTOR",
      tilt: 45,
      heading: 0,
    };
  }, [mapOptions, shouldRender3d]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        p: { xs: 0, md: 2 },
      }}
    >
      <Box
        sx={(theme) => ({
          width: "100%",
          height: "100%",
          position: "relative",
          overflow: "hidden",
          borderRadius: { xs: 0, md: 1 },
          boxShadow: {
            xs: "none",
            md: `0 10px 30px ${alpha(theme.palette.common.black, 0.14)}`,
          },
        })}
      >
        {deferMapRender ? (
          <Box
            sx={(theme) => ({
              width: "100%",
              height: "100%",
              display: "grid",
              placeItems: "center",
              backgroundColor: alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.18 : 0.04),
            })}
          >
            <CircularProgress size={30} aria-label="Loading map" />
          </Box>
        ) : shouldRender3d ? (
          <HomeGraphicalTiltMap3D
            center={mapRenderCenter}
            userLocation={userLocation}
            displayItems={displayItems}
            directions={directions}
            onLoad={onLoad}
            onDrag={onDrag}
            onDragEnd={onDragEnd}
            onIdle={onIdle}
            onMarkerClick={onMarkerClick}
            onClusterClick={onClusterClick}
            onLongPress={onLongPress}
            onPoiClick={onPoiClick}
            mapOptions={graphicalMapOptions}
            containerStyle={mapContainerStyle}
            onFallbackTo2D={handleFallbackTo2D}
          />
        ) : (
          <HomeTimeCapsuleMapV2
            center={mapRenderCenter}
            userLocation={userLocation}
            displayItems={displayItems}
            directions={directions}
            onLoad={onLoad}
            onDrag={onDrag}
            onDragEnd={onDragEnd}
            onIdle={onIdle}
            onMarkerClick={onMarkerClick}
            onClusterClick={onClusterClick}
            onLongPress={onLongPress}
            onPoiClick={onPoiClick}
            mapOptions={graphicalMapOptions}
            containerStyle={mapContainerStyle}
          />
        )}
      </Box>
    </Box>
  );
}
